import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogHeader from 'components/DialogHeader';
import QRCodeReaderDialog from 'components/QRCodeReaderDialog';
import QRCodeScannerDialog from 'components/QRCodeScannerDialog';
import ManualLookupDialog from 'areas/cardLookup/components/ManualLookupDialog';
import AuthChooserButton from 'components/AuthChooserButton';
import { H6 } from 'components/Typography';
import SwipeListPanel from 'areas/swipes/components/SwipeListPanel';
import filterTypes from 'areas/swipes/components/SwipeListPanel/filterTypes';
import CompetencyMonoIcon from 'components/Icons/Competency/CompetencyMono';
import { isDefined, isString } from 'utilities/is';
import styles from './styles';
import { toShortDateString } from 'utilities/formatters/dateTimeFormatter';

class ScanningPage extends React.Component {

    qrReaderDialog = () => {
        return (
            <QRCodeReaderDialog
                title="Scan a QR Code"
                open={this.props.qrDialogOpen}
                handleClose={this.props.closeQRDialog}
                onCardScanned={this.props.handleScan}
                onScanError={this.props.onScanError}
                onVisitorPassScanned={this.props.handleVisitorPassScan}
            />
        );
    };

    qrScannerDialog = () => {
        return (
            <QRCodeScannerDialog
                title="Scan a QR Code"
                open={this.props.qrScannerOpen}
                handleClose={this.props.closeQRDialog}
                onCardScanned={this.props.handleScan}
                onScanError={this.props.onScanError}
                onVisitorPassScanned={this.props.handleVisitorPassScan}
            />
        );
    };

    manualLookupDialog = () => {
        return (
            <ManualLookupDialog
                open={Boolean(this.props.manualLookupDialogOpen)}
                handleClose={this.props.closeManualLookupDialog}
                cardNumberLabel={this.props.config.productNumberName}
                onSubmit={this.props.handleManualLookup} />
        );
    };

    fabButtons() {
        return (
            <AuthChooserButton
                text="Award"
                icon={CompetencyMonoIcon}
                qrCodeClicked={this.props.openQRDialog}
                qrScannerClicked={this.props.openQRScannerDialog}
                forgottenCardClicked={this.props.openManualLookupDialog}
            />
        );
    }

    panelHeader() {
        return (<H6>Competencies</H6>);
    }

    filterSwipesByCompetence = () => {
        const activeCompetence = this.props.activeCompetence;
        if (isDefined(activeCompetence) && Boolean(activeCompetence)) {
            return (swipe) => swipe.competenceID === activeCompetence.competenceID;
        }

        return (_) => false;
    };

    swipePanel() {
        return (
            <SwipeListPanel
                emptyStateMessage={() => "Click the Award button to begin"}
                showEmptyFilterMessage={false}
                swipes={this.props.swipes || []}
                config={this.props.config}
                location={this.props.location}
                supervisorData={this.props.supervisorData}
                currentFilter={filterTypes.Competencies}
                additionalFilterFunc={this.filterSwipesByCompetence()}
                HeaderComponent={this.panelHeader}
            />
        );
    }

    render() {
        const { 
            selectedCompetenceName, 
            open, 
            classes, 
            closeScanningPage, 
            expiryDate } = this.props;

        const isOpen = Boolean(open);
        let title = `Award competencies for ${selectedCompetenceName}`;
        if (Boolean(expiryDate)) {
            title += ` expiring on ${isString(expiryDate) ? expiryDate : toShortDateString(expiryDate)}`;
        }

        return (
            <Dialog fullScreen open={isOpen} className={classes.body}>
                <DialogHeader
                    title={title}
                    handleClose={closeScanningPage}
                    showBackIcon={true} />
                <DialogContent className={classes.body}>
                    {this.qrReaderDialog()}
                    {this.qrScannerDialog()}
                    {this.manualLookupDialog()}
                    {this.swipePanel()}
                    {this.fabButtons()}
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(styles)(ScanningPage);